import {ForestMassEdit, ForestMassList} from '@/admin/resources/forestMasses/ForestMasses';

export default {
  list: ForestMassList,
  edit: ForestMassEdit,
};
